import { render, staticRenderFns } from "./RemovePeakBtn.vue?vue&type=template&id=30fc9e6f&"
import script from "./RemovePeakBtn.vue?vue&type=script&lang=js&"
export * from "./RemovePeakBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports